/**
 * Created by yarik on 18.7.17.
 */
import lazyLoading from './lazyLoading'

export default {
  name: 'driverCard2',
  meta: {
    expanded: false,
    title: 'TARJETON',
    iconClass: 'vuestic-icon vuestic-icon-auth',
    isShareTrip: true,
  },
  children: [
    {
      name: 'driverCard',
      path: '/p/:driverId',
      component: lazyLoading('config/DriverCard'),
      meta: {
        title: 'Tarjeton',
        requiresAuth: false,
        isShareTrip: true,
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/driverCard2.js